import { createReducer } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import { ReduxActionTypes } from "legacy/constants/ReduxActionConstants";
import type { ReduxAction } from "legacy/constants/ReduxActionConstants";

import appViewReducer from "./appViewReducer";
import type { AppViewReduxState } from "./appViewReducer";
import dynamicFormReducer from "./dynamicFormReducer";
import type { DynamicFormState } from "./dynamicFormReducer";
import errorReducer from "./errorReducer";
import type { ErrorReduxState } from "./errorReducer";
import explorerReducer from "./explorerReducer";
import type { ExplorerReduxState } from "./explorerReducer";
import globalReducer from "./global";
import type { GlobalState } from "./global";
import modalReducer from "./modalReducer";
import type { ModalState } from "./modalReducer";
import orgReducer from "./orgReducer";
import type { OrgReduxState } from "./orgReducer";
import usersReducer from "./usersReducer";
import type { UsersReduxState } from "./usersReducer";

export interface UiState {
  errors: ErrorReduxState;
  appView: AppViewReduxState;
  orgs: OrgReduxState;
  users: UsersReduxState;
  explorer: ExplorerReduxState;
  modal: ModalState;
  globalStates: GlobalState;
  isSplitPaneDragging: boolean;
  isAiAssistantDragging: boolean;
  dynamicForm: DynamicFormState;
}

export default combineReducers({
  errors: errorReducer,
  appView: appViewReducer,
  orgs: orgReducer,
  users: usersReducer,
  explorer: explorerReducer,
  modal: modalReducer,
  globalStates: globalReducer,
  isSplitPaneDragging: createReducer(false, (builder) =>
    builder.addCase(
      ReduxActionTypes.SET_SPLIT_PANE_DRAGGING,
      (
        state,
        action: ReduxAction<
          boolean,
          typeof ReduxActionTypes.SET_SPLIT_PANE_DRAGGING
        >,
      ) => {
        return action.payload;
      },
    ),
  ),
  isAiAssistantDragging: createReducer(false, (builder) =>
    builder.addCase(
      ReduxActionTypes.SET_AI_ASSISTANT_DRAGGING,
      (
        state: boolean,
        action: ReduxAction<
          boolean,
          typeof ReduxActionTypes.SET_AI_ASSISTANT_DRAGGING
        >,
      ) => {
        return action.payload;
      },
    ),
  ),
  dynamicForm: dynamicFormReducer,
});
